<template>
  <div v-if="currentConfig">
    <div :class="{
      guide: isGuide,
    }">
      <el-popover ref="popoverW" placement="bottom-end" width="280" v-model="isShowTips" trigger="manual">
        <p>登录成功！立即启动机器人?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="cancelTips">取消</el-button>
          <el-button type="primary" size="mini" @click="startRobot">确定</el-button>
        </div>
      </el-popover>
      <el-popover ref="popoverY" :offset="10" placement="top-end" width="300" v-model="isShowCloseTips" trigger="manual">
        <p>您主动停止了机器人，下次将不会自动启动。</p>
        <div style="text-align: right; margin: 0; position: relative">
          <el-button type="primary" size="mini" @click="isShowCloseTips = false">我知道了</el-button>
        </div>
      </el-popover>
      <el-row v-if="cloud.user != null">
        <el-col :span="5" v-if="!isDialog">场控号</el-col>
        <el-col :span="19">
          <div class="admin-account" v-popover:popoverW>
            <div class="img-box">
              <img :src="cloud.user.userLogo" alt />
            </div>
            <div class="info">
              <div class="account">
                <i v-if="cloud.user.accountType &&
                  cloud.user.accountType != 0 &&
                  cloud.user.accountType != -1
                  " :class="{
    'admin-red': cloud.user.accountType != 3,
    'admin-blue': cloud.user.accountType == 3,
  }">{{ cloud.user.accountType == 1 ? "主" : "管" }}</i>
                <span>{{ cloud.user.userNick }}</span>
                <i class="level-icon" :class="`level-icon${cloud.user.level}`"></i>
                <i class="noble-icon" :class="`noble-level-${cloud.user.noble_level}`"
                  v-if="cloud.user.noble_level > 0"></i>
              </div>
              <div class="action">
                <span v-if="!isGuide" class="status" :class="{
                  working: cloudStatus === 1,
                  waiting: cloudStatus === 4,
                  booting: cloudStatus === 0 && cloudLoading,
                  stopped: cloudStatus === 2,
                }"></span>
                <button type="button" @click="cloudLogout" class="el-button el-button--default el-button--mini">
                  <span>退出</span>
                </button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="5" v-if="!isDialog">场控号</el-col>
        <el-col :span="19">
          <div class="admin-account" :class="{
            center: isDialog || isGuide,
          }" v-if="!isCloud && isElectron">
            <el-button style="float: none" type="primary" @click="accountLogin"
              :loading="accountLoginStatus">登录</el-button>
          </div>
          <div class="admin-account" :class="{
            expire: isShowRefreshBtn,
            center: isDialog || isGuide,
            disable: !isCloud && !isElectron,
          }" @click="!isCloud && !isElectron ? openDownloadPage() : ''" v-else>
            <el-radio-group v-model="cloudLoginTabs" class="login-tab">
              <el-radio-button label="hyLogin">账密登录</el-radio-button>
              <el-radio-button label="accountLogin">短信登录</el-radio-button>
              <el-radio-button label="qrcodeLogin">扫码登录</el-radio-button>
            </el-radio-group>
            <div v-if="cloudLoginTabs == 'hyLogin'">
              <div class="row-padding">
                <el-input v-model.trim="username" placeholder="请输入账号" @focus="inputFocus" @blur="inputBlur" tabindex="1">
                  <el-button slot="prepend">
                    <i class="fa-user-circle"></i>
                  </el-button>
                </el-input>
              </div>
              <div class="row-padding">
                <el-input v-model.trim="password" placeholder="请输入密码" @keypress.native="passwordInputFocus"
                  ref="loginPasswd" show-password tabindex="2" @keydown.enter.native="loginWithPassword">
                  <el-button slot="prepend">
                    <i class="fa-key" v-show="!bigChar"></i>
                    <span v-show="bigChar">大写</span>
                  </el-button>
                </el-input>
              </div>
              <div class="row-padding login-btn-row">
                <el-button type="primary" @click="loginWithPassword" :loading="accountLoginStatus">登录</el-button>
                <div class="row-padding" v-if="isCloud">
                  <el-switch v-model="currentConfig.cloud.autoLogin.enable"></el-switch>
                  自动续登
                </div>
              </div>
            </div>
            <div class="qrcode-login" :class="{
              scaned: cloudQrCodeStage == 1,
            }" v-if="cloudLoginTabs == 'qrcodeLogin'">
              <div class="qrcode" :class="{
                expire: isShowRefreshBtn,
              }">
                <img :src="cloudQrCode || preLodingImg" />
                <el-button size="mini" icon="fa-refresh" v-if="isShowRefreshBtn" @click="getCloudQrCode">刷新</el-button>
              </div>
              <div class="teach"></div>
            </div>
            <div v-if="cloudLoginTabs == 'accountLogin'">
              <div class="row-padding">
                <el-input v-model.trim="phoneNum" placeholder="请输入手机号" @focus="inputFocus" @blur="inputBlur"
                  @input="phoneNumInput" class="input-with-select" tabindex="3">
                  <el-select v-model="areaCode" slot="prepend" placeholder="请选择">
                    <el-option-group v-for="group in areaCodeList" :key="group.label" :label="group.label">
                      <el-option v-for="item in group.options" :key="item.en" :label="`+${item.code}`" :value="item.code">
                        <span style="float: left">{{ item.zh }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">+{{ item.code }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-input>
              </div>
              <div class="row-padding">
                <el-input v-model.trim="vCode" placeholder="请输入验证码" class="input-with-select" ref="vCodeInput1"
                  @focus="inputFocus" @blur="inputBlur" tabindex="4" @keydown.enter.native="loginWithPhone">
                  <template slot="append">
                    <el-button type="primary" @click="vCodeTime ? '' : getVCode()" :disabled="vcodeClickLoading">{{
                      vCodeTime ? `重新获取(${vCodeTime}s)` : "获取验证码"
                    }}</el-button>
                  </template>
                </el-input>
              </div>
              <div class="row-padding login-btn-row">
                <div></div>
                <el-button type="primary" @click="loginWithPhone" :disabled="clickLoading"
                  :loading="clickLoading">登录</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="虎牙登录验证码" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :width="isPC ? '350px' : '95%'" :visible.sync="loginsms.showImage" v-if="loginsms.showImage">
      <div class="xhd_smslogin_image_wrap">
        <el-input v-model.trim="loginsms.code" placeholder="请输入验证码" @focus="inputFocus" @blur="inputBlur"></el-input>
        <img :src="loginsms.imgInfo" alt="图片验证码" @click="showAuthImage" />
      </div>
      <el-button type="primary" :loading="clickLoading" @click="verifyAuthImage" size="medium"
        class="xhd_auth_btn">确定</el-button>
    </el-dialog>
    <el-dialog title="虎牙登录验证" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :width="isPC ? '350px' : '95%'" :visible.sync="showPsSms" v-if="showPsSms">
      <div>
        虎牙需要进一步验证，验证码已经发送到绑定的手机上（{{
          psSmsQuery.mobile
        }}）！
      </div>
      <div class="row-padding">
        <el-input v-model.trim="psCode" placeholder="请输入手机验证码" class="input-with-select" ref="vCodeInput1"
          @focus="inputFocus" @blur="inputBlur">
          <template slot="append">
            <el-button type="primary" :disabled="vcodeClickLoading" @click="tickTime ? '' : psSmsSendFun()">{{
              tickTime ? `重新获取(${tickTime}s)` : "获取验证码"
            }}</el-button>
          </template>
        </el-input>
      </div>
      <div class="xhd_psauth_btn">
        <el-button type="primary" :loading="clickLoading" @click="psVerifyCode" size="medium">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="虎牙登录验证码" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :width="isPC ? '350px' : '95%'" :visible.sync="frameInfo.show" @close="closeIframe" v-if="frameInfo.show">
      <iframe v-if="frameInfo.show" :src="frameInfo.src" height="300" width="100%"></iframe>
      <div>*验证通过以后，请关闭对话框*</div>
    </el-dialog>
  </div>
</template>

<script>
import {
  cloudStop,
  getCloudStatus,
  cloudStart,
  cloudLogin,
  cloudLogout,
  getCloudQrCode,
  checkCloudLogin,
  passwordLogin,
  smsImgInfo,
  smsImgVerify,
  psSmsSend,
  psSmsVerify,
  updateConfig,
  checkAccountType,
  updateAccount,
  deleteAccount,
} from "@/api/index";
import { Message } from "element-ui";
import countryOptions from "@/assets/js/countryOptions.json";
import { mapState, mapActions } from "vuex";
import preLodingImg from "@/assets/pic/qrcode-loading.png";

let startAt = 0;

export default {
  data() {
    return {
      currentConfig: null,
      cloudLoginTabs: "hyLogin",
      accountList: {},
      timer: null,
      phoneNum: "",
      vCode: "",
      vCodeTime: 0,
      areaCode: 86,
      sessionData: "",
      areaCodeList: countryOptions,
      accountLoginStatus: false,
      isShowLogin: true,
      isShowRefreshBtn: false,
      isShowTips: false,
      isShowCloseTips: false,
      cloudStatus: 0,
      username: "",
      password: "",
      cloudQrcodeData: null,
      cloudQrCode: "",
      cloudQrCodeStage: 0,
      cloudLoading: false,
      authId: "", //账密登录，验证通过返回的authId
      authPage: "", // 账密登录，手机短信验证 页面url
      showPsSms: false, //账号密码登录 ，需要填写手机验证码弹窗
      psCode: "", //账密登录，短信验证码
      psSmsQuery: {}, //账密登录的是，短信验证query
      tickInterval: null,
      tickTime: 0,
      loginsms: {
        //短信登录相关数据
        agentIdx: null, // 代理ipindex
        query: null, // 图片获取的query
        captchaId: null, // 图片id
        imgInfo: null,
        code: "", //s输入的验证码
        showImage: false, // 是否显示图片验证码
      },
      preLodingImg: preLodingImg,
      bigChar: false,
      frameInfo: {
        show: false,
        src: "",
      },
      clickLoading: false,
      vcodeClickLoading: false,
    };
  },
  props: {
    isCloud: {
      type: Boolean,
      default: true,
    },
    configure: {
      type: Object,
      default: null,
    },
    robotLabel: {
      type: String,
      default: "",
    },
    roomId: {
      type: String,
      default: "",
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    isGuide: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      isPC: (state) => state.isPC,
      isElectron: (state) => state.isElectron,
      cloud: (state) => state.cloud,
    }),
  },
  watch: {
    cloudLoginTabs(val) {
      if (val == "qrcodeLogin") {
        if (!this.cloudQrCode) {
          this.getCloudQrCode();
          return;
        }
        this.checkCloudLogin(this.cloudQrcodeData);
      } else {
        clearInterval(this._cloudTimer);
      }
    },
  },
  mounted() {
    this.getCloudStatus();
    this.currentConfig = this.configure;
    window.addEventListener("message", this.onIframeMessage);
  },
  destroyed() {
    clearInterval(this._cloudTimer);
    clearTimeout(this._cloudStatusTimer);
    this.username = "";
    this.password = "";
    window.removeEventListener("message", this.onIframeMessage);
  },
  methods: {
    ...mapActions(["updateClouduser"]),
    onIframeMessage(e) {
      if (!e.data.param) return;
      const { param } = JSON.parse(e.data) || {};
      if (param && param.returnCode == 0) {
        // 登陆成功，可以关闭iframe了
        this.frameInfo.show = false;
        this.loginWithPassword();
      }
    },
    async checkCloudLogin(data) {
      clearInterval(this._cloudTimer);
      if (!data.context) return;
      this._cloudTimer = setInterval(() => {
        checkCloudLogin(
          {
            qr_context: data.context,
            qr_id: data.data.qrId,
            web_qrlogin_confirm_id: data.cookie.split("=")[1],
            ticket: this.ticket,
            query: +new Date(),
          },
          { notify: false }
        ).then((res) => {
          if (res.code === -3060) {
            clearInterval(this._cloudTimer);
            return;
          }
          if (res.code === -3070) {
            clearInterval(this._cloudTimer);
            return;
          }
          if (res.code === 0) {
            const stage = res.data.data.stage;
            this.cloudQrCodeStage = stage;
            if (stage == 2) {
              this.cloudQrCode = "";
              clearInterval(this._cloudTimer);
              this.getCloudStatus(false, true);
              //二维码登录成功，就重置保存的账号密码信息，防止续登
              this.currentConfig.cloud.autoLogin.account = "";
              this.currentConfig.cloud.autoLogin.password = "";
              this.currentConfig.cloud.autoLogin.enable = false;
              this.save();
            }
            if (stage == 5) {
              // this.getCloudQrCode();
            }
          }
        });
        if (Date.now() - startAt > 4.5 * 60e3) {
          clearInterval(this._cloudTimer);
          this.isShowRefreshBtn = true;
        }
      }, 2e3);
    },
    checkAccountType(cb) {
      if (!this.roomId) {
        cb &&
          cb({
            data: {
              data: -1,
            },
          });
        return;
      }
      checkAccountType({
        ticket: this.ticket,
        roomId: this.roomId,
      }).then((res) => {
        if (res.code == 0) {
          cb && cb(res);
        }
      });
    },
    async getVCode() {
      if (!this.phoneNum) {
        this.$message.error("请输入手机号");
        return;
      }
      this.vcodeClickLoading = true;
      let phoneNum = `${this.areaCode == 86 ? `0${this.areaCode}` : `00${this.areaCode}`
        }${this.phoneNum}`;
      if (!this.isCloud) {
        if (window.electron) {
          const data = await window.electron.remote.app.huyaServer.loginSMS(
            phoneNum
          );
          if (data.description) {
            Message({
              showClose: true,
              message: data.description,
              type: "error",
            });
            return;
          }
          this.sessionData = data.data.sessionData;
          this.$refs.vCodeInput1.focus();
          this.vCodeTime = 60;
          let timer = setInterval(() => {
            this.vCodeTime--;
            if (this.vCodeTime <= 0) {
              clearInterval(timer);
              this.vCodeTime = 0;
            }
          }, 1000);
        } else {
          setTimeout(() => {
            this.getVCode();
          }, 1000);
        }
      } else {
        cloudLogin({
          phone: phoneNum,
          ticket: this.ticket,
          agentIdx: this.loginsms.agentIdx,
        }).then((res) => {
          if (res.code == 0) {
            this.$refs.vCodeInput1.focus();
            this.vCodeTime = 60;
            let timer = setInterval(() => {
              this.vCodeTime--;
              if (this.vCodeTime <= 0) {
                clearInterval(timer);
                this.vCodeTime = 0;
              }
            }, 1000);
          } else {
            if (res.code == 400) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>短信登录失败</strong><p style="margin-top: 5px;">请尝试其他登录方式</p>',
              });
              setTimeout(() => {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`,
                });
              }, 1e3);
            }
          }
          this.vcodeClickLoading = false;
        });
      }
    },
    async showAuthImage() {
      smsImgInfo({
        ticket: this.ticket,
        query: this.loginsms.query,
        agentIdx: this.loginsms.agentIdx,
        captchaId: this.loginsms.captchaId,
      }).then((res) => {
        this.loginsms.showImage = true;
        if (res.code === 0) {
          this.loginsms.captchaId = res.data.data.captchaID;
          this.loginsms.imgInfo = `data:image/png;base64, ${res.data.data.buffer}`;
        }

        if (res.code == -2) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>获取图片验证码失败</strong><p style="margin-top: 5px;">错误码「-2」，请联系客服</p>',
          });
        }

        if (res.code == -3) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>获取图片验证码失败</strong><p style="margin-top: 5px;">若多次失败，请联系客服</p>',
          });
        }
      });
    },
    async verifyAuthImage() {
      if (!this.loginsms.code) {
        this.$message.error("请填写验证码");
        return;
      }
      this.clickLoading = true;
      smsImgVerify({
        ticket: this.ticket,
        query: this.loginsms.query,
        agentIdx: this.loginsms.agentIdx,
        code: this.loginsms.code.trim(),
        captchaId: this.loginsms.captchaId,
      }).then((res) => {
        // 验证通过
        if (res.data && res.data.returnCode === 0) {
          this.loginsms.showImage = false;
          this.loginsms.captchaId = null;
          this.loginsms.imgInfo = null;
          this.loginsms.code = null;
          if (this.cloudLoginTabs == "accountLogin") {
            this.loginsms.query = null;
            this.getVCode();
          }
          if (this.cloudLoginTabs == "hyLogin") {
            if (res.data.data.nextAction == 2 && !res.data.data.authId) {
              this.authPage = res.data.data.nextAuthUrl;
              this.psSmsQuery = {};
              this.authPage
                .split("?")[1]
                .split("&")
                .map((item) => {
                  let temp = item.split("=");
                  this.psSmsQuery[temp[0]] = decodeURIComponent(temp[1]);
                });
              this.psSmsSendFun();
            } else if (res.data.data.authId) {
              this.loginsms.query = null;
              this.authId = res.data.data.authId;
              this.loginWithPassword();
            } else {
              this.$message.error("登录异常");
            }
          }
        } else {
          //验证没通过
          if (res.code == -2) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>获取图片验证码失败</strong><p style="margin-top: 5px;">错误码「-2」，请联系客服</p>',
            });
          }
          if (res.code == -1) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>图片验证码输入错误</strong><p style="margin-top: 5px;">若多次失败，请联系客服</p>',
            });
          }
          this.showAuthImage();
        }
        this.clickLoading = false;
      });
    },
    psSmsSendFun() {
      this.vcodeClickLoading = true;
      clearInterval(this.tickInterval);
      psSmsSend({
        query: this.psSmsQuery,
        agentIdx: this.loginsms.agentIdx,
        ticket: this.ticket,
      }).then((res) => {
        if (res && res.code === 0) {
          this.showPsSms = true;
          this.tickTime = 60;
          this.tickInterval = setInterval(() => {
            this.tickTime--;
            if (this.tickTime === 0) {
              clearInterval(this.tickInterval);
            }
          }, 1e3);
        } else {
          if (res.code == 400) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>获取短信验证码失败</strong><p style="margin-top: 5px;">若多次失败，请联系客服</p>',
            });
          }
        }
        this.vcodeClickLoading = false;
      });
    },
    psVerifyCode() {
      if (!this.psCode) {
        return this.$message.error("请输入验证码");
      }
      this.clickLoading = true;
      psSmsVerify({
        query: this.psSmsQuery,
        agentIdx: this.loginsms.agentIdx,
        ticket: this.ticket,
        page: this.authPage,
        code: this.psCode,
      }).then((res) => {
        this.clickLoading = false;
        if (res.code === 0) {
          clearInterval(this.tickInterval);
          this.psCode = "";
          this.$message.success("验证通过");
          this.showPsSms = false;
          this.authId = res.data.authId;
          this.loginWithPassword();
          return;
        } else {
          if (res.code == 400) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>短信验证码输入错误</strong><p style="margin-top: 5px;">若多次失败，请联系客服</p>',
            });
          }
          return;
        }
      });
    },
    async loginWithPhone() {
      if (!this.phoneNum) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.vCode) {
        this.$message.error("请输入验证码");
        return;
      }
      this.clickLoading = true;
      let phoneNum = `${this.areaCode == 86 ? `0${this.areaCode}` : `00${this.areaCode}`
        }${this.phoneNum}`;
      cloudLogin({
        phone: phoneNum,
        ticket: this.ticket,
        code: this.vCode,
        sessionData: this.sessionData,
      }).then((res) => {
        if (res.code == 0) {
          this.updateClouduser({
            user: res.data,
          });
          this.phoneNum = "";
          this.vCodeTime = 0;
          this.vCode = "";
          clearInterval(this._cloudTimer);
          // this.isShowTips = true;
          this.getCloudStatus(false, true);
          this.$message.success("登录成功");
          //手机登录成功，就重置账密登录配置
          this.currentConfig.cloud.autoLogin.account = "";
          this.currentConfig.cloud.autoLogin.password = "";
          this.currentConfig.cloud.autoLogin.enable = false;
          this.save();
          // this.$emit("startRobotConfirm", "login")
        } else {
          if (res.code == 401) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message: `<strong>短信登录失败</strong><p style="margin-top: 5px;">${res.message}</p>`,
            });
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message: `<strong>短信登录失败</strong><p style="margin-top: 5px;">请尝试其他登录方式</p>`,
            });
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`,
              });
            }, 1e3);
          }
        }
        this.clickLoading = false;
      });
    },
    //账密登录
    loginWithPassword() {
      if (!this.username) {
        this.$message.error("请输入账号");
        return;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.accountLoginStatus) {
        return;
      }
      this.accountLoginStatus = true;
      passwordLogin(
        {
          username: this.username,
          ticket: this.ticket,
          password: this.password,
          agentIdx: this.loginsms.agentIdx,
          authId: this.authId,
        },
        {
          notify: false,
        }
      ).then((res) => {
        this.authId = "";
        this.accountLoginStatus = false;
        if (res.code == 0) {
          // this.updateClouduser({
          //   user: res.data
          // })
          this.currentConfig.cloud.autoLogin.account = this.username;
          this.currentConfig.cloud.autoLogin.password = this.password;
          // this.isShowTips = true;
          // setTimeout(() => {
          this.getCloudStatus(false, true);
          this.save();
          this.$emit("savechange");
          // }, 2e3)
          // this.$message.success('登录成功')
          // this.$emit("startRobotConfirm", "login");
        } else {
          if (res.code === 10030 || res.code == 10039) {
            //验证码的校验
            // this.loginsms.agentIdx = res.data.agentIdx
            // this.loginsms.query = res.data.query
            // this.showAuthImage()
            this.frameInfo.show = true;
            this.frameInfo.src = res.data.verify;
            return;
          }
          if (res.code == 401) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message: `<strong>登录失败</strong><p style="margin-top: 5px;">${res.message}</p>`,
            });
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message: `<strong>登录失败，请联系客服</strong><p style="margin-top: 5px;">错误码「${res.code}」，请联系客服</p>`,
            });
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`,
              });
            }, 1e3);
          }
        }
      });
    },
    closeIframe() {
      this.frameInfo.show = false;
      this.frameInfo.src = "";
      this.accountLoginStatus = false;
    },
    // 场控登录
    async accountLogin() {
      this.accountLoginStatus = true;
      let data = await huyaLogin();
      if (data) {
        if (!localStorage["accountList"]) {
          this.accountList = {};
        }
        data.user.login_at = new Date(data.timestamp).toISOString();
        data.user.name = data.user.userNick;
        data.user.avatar = data.user.userLogo;
        this.accountList[this.ticket] = data;
        localStorage["accountList"] = JSON.stringify(this.accountList);
        this.updateClouduser(
          this.accountList[this.ticket] ? this.accountList[this.ticket] : null
        );
        this.$emit("loginStatusChange", "login");
        this.$message.success("登录成功");
        updateAccount({
          ticket: this.ticket,
          accountUid: data.user.uid,
          cookie: data.cookies,
          userinfo: JSON.stringify(data.user),
        }).then((res) => {
          if (res.code == 0) {
            this.loginCompleted();
          }
        });
        this.checkAccountType((accountTypeRes) => {
          data.user.accountType =
            accountTypeRes.code == 0 ? accountTypeRes.data.data : -1;
          this.accountList[this.ticket] = data;
          localStorage["accountList"] = JSON.stringify(this.accountList);
          this.updateClouduser(
            this.accountList[this.ticket] ? this.accountList[this.ticket] : null
          );
          if (data.user.accountType == 1) {
            this.$message({
              dangerouslyUseHTMLString: true,
              message:
                '场控为主播号，可以打开「<a href="#subscribe">感谢订阅</a>」哦',
              type: "warning",
            });
          }
          if (this.accountList[this.ticket].user.level <= 3) {
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  '您的场控号等级过低，发言过频容易被判定为广告号被「<a href="https://xiaohudi.com/entry/1.html?from=singlemessage&isappinstalled=0&scene=1&clicktime=1583721512&enterid=1583721512" target="_blank">吞字</a>」',
                type: "warning",
              });
            }, 50);
          }
          if (
            this.accountList[this.ticket].user.accountType == 0 ||
            this.accountList[this.ticket].user.accountType == -1
          ) {
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  '您的场控号不是房管，发言过频容易「<a href="https://xiaohudi.com/entry/1.html?from=singlemessage&isappinstalled=0&scene=1&clicktime=1583721512&enterid=1583721512" target="_blank">吞字</a>」',
                type: "warning",
              });
            }, 150);
          }
        });
      } else {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`,
        });
      }
      this.accountLoginStatus = false;
    },
    loginCompleted() {
      setTimeout(() => {
        if (
          this.isGuide &&
          this.accountList[this.ticket].user.accountType == 1
        ) {
          this.currentConfig.welcome.welcomeTourist = true;
          this.currentConfig.giftTks.subscribe.enable = true;
        }
        if (!this.isGuide) {
          this.isShowTips = true;
        }
      }, 15e2);
      if (this.isElectron) {
        this.sendConfigChange();
      } else {
        this.sendDataChange();
      }
    },
    async getCloudQrCode() {
      if (!this.isCloud) {
        if (window.electron) {
          const data =
            await window.electron.remote.app.huyaServer.loginQrcode();
          this.cloudQrCode = data.image;
          this.isShowRefreshBtn = false;
          this.cloudQrcodeData = data;
          if (this.cloudLoginTabs == "qrcodeLogin") {
            this.checkCloudLogin(this.cloudQrcodeData);
          }
        } else {
          setTimeout(() => {
            this.getCloudQrCode();
          }, 1000);
        }
      } else {
        getCloudQrCode({ ticket: this.ticket }, { notify: false }).then(
          (res) => {
            const data = res.data;
            this.cloudQrCode = data.image;
            this.isShowRefreshBtn = false;
            this.cloudQrcodeData = data;
            if (this.cloudLoginTabs == "qrcodeLogin") {
              startAt = Date.now();
              this.checkCloudLogin(this.cloudQrcodeData);
            }
          }
        );
      }
    },
    isAccountExpire(timestamp) {
      // let r = await new Promise((res) => {
      //     setTimeout(() => { res() }, 0);
      // });
      let timeStamp = parseInt((+new Date() - timestamp) / 86400000) >= 7;
      if (timeStamp) {
        return true;
      } else {
        return false;
      }
    },
    getCloudStatus(loop = false, cloudLogin = false, type = "default") {
      this.accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      if (
        this.accountList[this.ticket] &&
        this.isAccountExpire(this.accountList[this.ticket].timestamp)
      ) {
        delete this.accountList[this.ticket];
        localStorage["accountList"] = JSON.stringify(this.accountList);
        this.cloudLogoutFuc();
        return;
      }
      if (!this.isCloud) {
        if (this.accountList[this.ticket]) {
          this.updateClouduser(this.accountList[this.ticket]);
          this.cloudStatus = this.accountList[this.ticket].user
            ? this.accountList[this.ticket].user.status
            : this.accountList[this.ticket].status;
        } else {
          this.updateClouduser({ user: null });
        }
      } else {
        getCloudStatus(
          { ticket: this.ticket, query: +new Date() },
          { notify: false }
        ).then((res) => {
          if (res.code == 0) {
            clearInterval(this._cloudTimer);
            if (!loop) {
              if (res.data.status != 3) {
                if (this.accountList[this.ticket]) {
                  this.updateClouduser(this.accountList[this.ticket]);
                } else {
                  if (res.data.user) {
                    let user = res.data.user;
                    delete user.cookie;
                    let data = {
                      cookies: res.data.cookie,
                      timestamp: res.data.loginAt,
                      user,
                    };
                    if (!localStorage["accountList"]) {
                      this.accountList = {};
                    }
                    this.accountList[this.ticket] = data;
                    localStorage["accountList"] = JSON.stringify(
                      this.accountList
                    );
                    this.updateClouduser(
                      this.accountList[this.ticket]
                        ? this.accountList[this.ticket]
                        : null
                    );
                    this.$emit("loginStatusChange", "login");
                    this.checkAccountType((accountTypeRes) => {
                      data.user.accountType =
                        accountTypeRes.code == 0
                          ? accountTypeRes.data.data
                          : -1;
                      this.accountList[this.ticket] = data;
                      localStorage["accountList"] = JSON.stringify(
                        this.accountList
                      );
                      this.updateClouduser(
                        this.accountList[this.ticket]
                          ? this.accountList[this.ticket]
                          : null
                      );
                      if (cloudLogin) {
                        if (data.user.accountType == 1) {
                          this.$message({
                            dangerouslyUseHTMLString: true,
                            message:
                              '场控为主播号，可以打开「<a href="#subscribe">感谢订阅</a>」哦',
                            type: "warning",
                          });
                        }
                        if (this.accountList[this.ticket].user.level <= 3) {
                          setTimeout(() => {
                            this.$message({
                              dangerouslyUseHTMLString: true,
                              message:
                                '您的场控号等级过低，发言过频容易被判定为广告号被「<a href="https://xiaohudi.com/entry/1.html?from=singlemessage&isappinstalled=0&scene=1&clicktime=1583721512&enterid=1583721512" target="_blank">吞字</a>」',
                              type: "warning",
                            });
                          }, 50);
                        }
                        if (
                          this.accountList[this.ticket].user.accountType == 0 ||
                          this.accountList[this.ticket].user.accountType == -1
                        ) {
                          setTimeout(() => {
                            this.$message({
                              dangerouslyUseHTMLString: true,
                              message:
                                '您的场控号不是房管，发言过频容易「<a href="https://xiaohudi.com/entry/1.html?from=singlemessage&isappinstalled=0&scene=1&clicktime=1583721512&enterid=1583721512" target="_blank">吞字</a>」',
                              type: "warning",
                            });
                          }, 150);
                        }
                        this.loginCompleted();
                        // this.$emit('startRobotConfirm', 'login')
                      }
                      this.$emit("loginStatusChange", "login");
                    });
                    updateAccount({
                      ticket: this.ticket,
                      accountUid: data.user.uid,
                      cookie: data.cookies,
                      userinfo: JSON.stringify(data.user),
                    }).then((res) => {
                      if (res.code == 0) {
                      }
                    });
                  } else {
                    this.updateClouduser({ user: null });
                  }
                }
                // this.sendConfigChange();
              }
            }
            this.cloudStatus = res.data.status;
            if (this.isElectron && type == "start") {
              if (this.cloudStatus == 2 || this.cloudStatus == 0) {
                if (res.data.cookie) {
                  this.$emit("openElectronRobot", {
                    ticket: this.ticket,
                    cookie: res.data.cookie,
                  });
                }
              } else {
                Message({
                  showClose: true,
                  message: `云端版正在运行，请先到公众号配置后台停止云端机器人`,
                  type: "error",
                });
              }
              return;
            }
            if (res.data.status === 1) {
              if (this.cloudLoading) {
                Message({
                  showClose: true,
                  message: `${this.robotLabel}启动成功`,
                  type: "success",
                });
                this.cloudLoading = false;
                if (this.isElectron) {
                  this.sendConfigChange();
                } else {
                  this.sendDataChange();
                }
              }
              return;
            }
            clearTimeout(this._cloudStatusTimer);
            this._cloudStatusTimer = setTimeout(
              () => {
                this.getCloudStatus(true);
              },
              res.data.status == 1 ? 12e3 : this.cloudLoading ? 2e3 : 10e3
            );
            if (res.data.status === 3) {
              Message({
                showClose: true,
                message: res.data.error,
                type: "error",
              });
              clearTimeout(this._cloudStatusTimer);
              this.updateClouduser({
                user: null,
              });
              // this.getCloudQrCode()
            }
          } else {
            clearTimeout(this._cloudStatusTimer);
            this.updateClouduser({
              user: null,
            });
            delete this.accountList[this.ticket];
            localStorage["accountList"] = JSON.stringify(this.accountList);
            this.$emit("loginStatusChange");
            // this.getCloudQrCode()
          }
        });
      }
    },
    cloudStart() {
      if (this.currentConfig.global.liveRoomUrl) {
        // TODO
        if (this.isElectron && this.currentConfig.readText.enable) {
          this.getCloudStatus(true, false, "start");
        } else {
          cloudStart({
            url: this.currentConfig.global.liveRoomUrl,
            ticket: this.ticket,
            query: +new Date(),
          }).then((res) => {
            if (res.code == 0) {
              this.cloudLoading = true;
              this.getCloudStatus(true);
              setTimeout(() => {
                this.cloudLoading = false;
                this.sendDataChange();
              }, 20000);
              if (res.message) {
                this.$message.warning(res.message);
              }
            } else if (res.code == 401) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">基础功能已过期，请续费。</p>',
              });
            } else if (res.code == 404) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">错误码「404」，请联系客服</p>',
              });
            } else if (res.code == 500) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">错误码「500」，请联系客服</p>',
              });
            } else if (res.code == 400) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">缺少房间号或场控号信息</p>',
              });
            }
          });
        }
      } else {
        this.$message.warning("请输入要服务的直播间地址");
        this.$refs.roomUrlInput[0].focus();
      }
    },
    cloudStop() {
      cloudStop({ ticket: this.ticket, query: +new Date() }).then((res) => {
        // this.isShowCloseTips = true;
        this.getCloudStatus(true);
        if (this.isElectron) {
          this.sendConfigChange();
        } else {
          this.sendDataChange();
        }
      });
    },
    cloudLogout() {
      this.$confirm(`确定退出场控吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cloudLogoutFuc();
        })
        .catch(() => { });
    },
    cloudLogoutFuc() {
      if (!this.isCloud) {
        this.deleteAccount(() => {
          this.stopRobot({
            ticket: this.ticket,
          });
        });
      } else {
        this.cloudStop({
          ticket: this.ticket,
        });
        cloudLogout({
          ticket: this.ticket,
          query: +new Date(),
        }).then((res) => {
          if (res.code == 0) {
            this.deleteAccount(() => {
              this.getCloudQrCode();
              this.getCloudStatus();
              this.$emit("loginStatusChange", "logout");
            });
            // this.getCloudStatus()
          }
        });
      }
    },
    deleteAccount(cb) {
      deleteAccount({
        ticket: this.ticket,
      }).then((res) => {
        this.updateClouduser({
          user: null,
        });
        delete this.accountList[this.ticket];
        localStorage["accountList"] = JSON.stringify(this.accountList);
        cb && cb();
      });
    },
    stopRobot(json) {
      if (json.hasCloud) {
        this.pcRobotStop(json);
        this.cloudStop();
      } else {
        if (this.isElectron) {
          this.pcRobotStop(json);
        } else {
          this.$message.warning("电脑版用户，请下载小虎弟个人版启动");
        }
      }
    },
    async pcRobotStop(json) {
      if (this.isElectron) {
        const res = await manager.stopLocalRobot(json.ticket);
        if (res.code == -1) {
          this.cloudStop();
          return;
        }
        this.sendConfigChange();
      }
    },
    sendConfigChange() {
      if (this.isGuide) {
        return;
      }
      if (window.electron) {
        window.electron.ipcRenderer.send("configChange");
      } else {
        if (this.isElectron) {
          setTimeout(() => {
            this.sendConfigChange();
          }, 1000);
        }
      }
    },
    sendDataChange() {
      this.$configListen.notify();
    },
    save() {
      let isShowAIChatMes = false;
      this.configure.AIChat.symbolList.forEach((inputValue) => {
        if (
          !!~inputValue.indexOf("/{") ||
          !!~inputValue.indexOf("{") ||
          !!~inputValue.indexOf("/")
        ) {
          isShowAIChatMes = true;
        }
      });
      if (isShowAIChatMes) {
        return this.$message({
          showClose: true,
          message: "互动符号不能含有'/'或'{'符号",
          type: "error",
        });
      }
      if (
        (!this.configure.global.liveRoomName_config &&
          this.configure.global.liveRoomUrl) ||
        (this.configure.global.liveRoomName_config &&
          !this.configure.global.liveRoomUrl) ||
        (this.configure.global.liveRoomName_config &&
          this.configure.global.liveRoomUrl &&
          this.configure.global.liveRoomName_config == "无此房间")
      ) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>信息不完整</strong><p style="margin-top: 5px;">请确认房间号或房间名是否正确</p>',
        });
        return;
      }
      updateConfig({
        configure: JSON.stringify(this.currentConfig),
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          // this.$message.success("保存配置成功");
        }
      });
    }, // 保存配置
    passwordInputFocus(event) {
      if (!window.navigator.userAgent.indexOf("MSIE") > -1) {
        // 非IE
        var e = event || window.event;
        var keyvalue = e.keyCode || e.which;
        var isShift = e.shiftKey || keyvalue == 16 || false;
        if (
          (keyvalue >= 65 && keyvalue <= 90 && !isShift) ||
          (keyvalue >= 97 && keyvalue <= 122 && isShift)
        ) {
          this.bigChar = true;
        } else {
          this.bigChar = false;
        }
      }
    },
    inputFocus() {
      //滚动到顶部
      window.scrollTo(0, 0);
    },
    inputBlur() {
      document.body.scrollTop = 0;
    },
    openDownloadPage() {
      window.open("https://www.xiaohudi.com/download.html");
    },
    startRobot() {
      this.isShowTips = false;
      this.$emit("startRobot");
    },
    cancelTips() {
      this.isShowTips = false;
      this.$message({
        type: "info",
        message: "请稍后到机器人列表中启动",
      });
    },
    phoneNumInput(e) {
      this.phoneNum = e.replace(/[^\d]/g, "");
    },
  },
};
</script>
